(function () {
  function parseMoneyInput(raw) {
    const normalized = String(raw).replace(',', '.').replace(/[^\d.]/g, '');
    const value = parseFloat(normalized);
    if (isNaN(value)) return null;
    return Math.round(value * 100);
  }

  function formatFromCents(cents) {
    const value = cents / 100;
    if (Number.isInteger(value)) return String(value);
    return value.toFixed(2);
  }

  class PebblePriceRange extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._lastAppliedKey = null;

      this.inputMin = this.querySelector('.pebble-price-range__input-min, .price-range__input-min');
      this.inputMax = this.querySelector('.pebble-price-range__input-max, .price-range__input-max');
      this.hiddenMin = this.querySelector('.pebble-price-range__hidden-min, .price-range__hidden-min');
      this.hiddenMax = this.querySelector('.pebble-price-range__hidden-max, .price-range__hidden-max');
      this.formEl = this.closest('form');

      if (!this.inputMin || !this.inputMax || !this.formEl) return;

      this.minRange = parseFloat(this.dataset.min) || 0;
      this.maxRange = parseFloat(this.dataset.max) || 10000;

      this.bindInput(this.inputMin, () => this.onMinInputChange());
      this.bindInput(this.inputMax, () => this.onMaxInputChange());

      this._lastAppliedKey = this.getFilterKey();
    }

    disconnectedCallback() {
      this._initialized = false;
    }

    bindInput(input, handler) {
      input.addEventListener('change', handler);
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          input.blur();
        }
      });
    }

    getFilterKey() {
      const min = this.hiddenMin?.disabled ? '' : this.hiddenMin?.value || '';
      const max = this.hiddenMax?.disabled ? '' : this.hiddenMax?.value || '';
      return `${min}|${max}`;
    }

    getCurrentCents() {
      const minCents = parseMoneyInput(this.inputMin.value);
      const maxCents = parseMoneyInput(this.inputMax.value);
      return { minCents, maxCents };
    }

    syncHiddenInputs(minCents, maxCents) {
      if (this.hiddenMin) {
        if (minCents === null || minCents <= this.minRange) {
          this.hiddenMin.value = '';
          this.hiddenMin.disabled = true;
        } else {
          this.hiddenMin.disabled = false;
          this.hiddenMin.value = formatFromCents(minCents);
        }
      }

      if (this.hiddenMax) {
        if (maxCents === null || maxCents >= this.maxRange) {
          this.hiddenMax.value = '';
          this.hiddenMax.disabled = true;
        } else {
          this.hiddenMax.disabled = false;
          this.hiddenMax.value = formatFromCents(maxCents);
        }
      }
    }

    applyFilterNow() {
      if (!this.formEl) return;

      const key = this.getFilterKey();
      if (key === this._lastAppliedKey) return;
      this._lastAppliedKey = key;

      if (window.PebbleCollectionFilters) {
        window.PebbleCollectionFilters._lastAppliedParams = null;
        window.PebbleCollectionFilters.applyPartial();
        return;
      }

      const filterEl = this.closest('.js-filter');
      if (filterEl) {
        filterEl.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    onMinInputChange() {
      const { minCents, maxCents } = this.getCurrentCents();
      if (minCents === null) {
        this.restoreInputs();
        return;
      }

      let nextMin = Math.min(Math.max(minCents, this.minRange), this.maxRange);
      let nextMax = maxCents;

      if (nextMax === null) {
        nextMax = this.maxRange;
      } else {
        nextMax = Math.min(Math.max(nextMax, this.minRange), this.maxRange);
      }

      if (nextMin > nextMax) {
        nextMin = nextMax;
      }

      this.inputMin.value = formatFromCents(nextMin);
      this.inputMax.value = formatFromCents(nextMax);
      this.syncHiddenInputs(nextMin, nextMax);
      this.applyFilterNow();
    }

    onMaxInputChange() {
      const { minCents, maxCents } = this.getCurrentCents();
      if (maxCents === null) {
        this.restoreInputs();
        return;
      }

      let nextMax = Math.min(Math.max(maxCents, this.minRange), this.maxRange);
      let nextMin = minCents;

      if (nextMin === null) {
        nextMin = this.minRange;
      } else {
        nextMin = Math.min(Math.max(nextMin, this.minRange), this.maxRange);
      }

      if (nextMax < nextMin) {
        nextMax = nextMin;
      }

      this.inputMin.value = formatFromCents(nextMin);
      this.inputMax.value = formatFromCents(nextMax);
      this.syncHiddenInputs(nextMin, nextMax);
      this.applyFilterNow();
    }

    restoreInputs() {
      const minCents = this.hiddenMin?.disabled
        ? this.minRange
        : Math.round(parseFloat(this.hiddenMin?.value || '0') * 100);
      const maxCents = this.hiddenMax?.disabled
        ? this.maxRange
        : Math.round(parseFloat(this.hiddenMax?.value || '0') * 100);

      this.inputMin.value = formatFromCents(minCents);
      this.inputMax.value = formatFromCents(maxCents);
    }
  }

  if (!customElements.get('pebble-price-range')) {
    customElements.define('pebble-price-range', PebblePriceRange);
  }

  if (!customElements.get('price-range-filter')) {
    class PriceRangeFilter extends PebblePriceRange {}
    customElements.define('price-range-filter', PriceRangeFilter);
  }
})();
